import {
  ArticleListMapType,
  DocArticleType,
  DocMenuLinkType,
  DocMenuSectionType,
  DocMenuType,
} from 'routes/Docs/types'

import {
  filterPathWithUnderscore,
  removePrefixNumberFromPath,
  sortArrayOfArticles,
} from './helpers'

export function createDocMenuBasedOnArticleListMap(
  listMap: ArticleListMapType,
) {
  return getRootArticles(listMap)
    .filter((i) => !i.rawPath.startsWith('_'))
    .map(transformDocArticleToDocMenu)
}

function getRootArticles(listMap: ArticleListMapType): DocArticleType[] {
  const result: DocArticleType[] = []
  const listMapValues = listMap.values()
  for (const article of listMapValues) {
    if (article.parentRawPath === undefined) {
      result.push(article)
    }
  }

  return sortArrayOfArticles(result).filter((article) => {
    return removePrefixNumberFromPath(article.rawPath)
  })
}

function transformDocArticleToDocMenu(article: DocArticleType): DocMenuType {
  // if no component found it is a section
  const title = article.title
  const isBeta = article.isBeta
  const links = article.children
    ?.filter((art) => filterPathWithUnderscore(art.rawPath))
    .map(transformDocArticleToDocMenu)

  if (!article.Component) {
    return {
      title,
      links,
      isSection: true,
    } as DocMenuSectionType
  }

  return {
    title: article.title,
    path: article.path,
    links: links,
    isBeta,
  } as DocMenuLinkType
}
